import { Injectable } from '@angular/core';

import { UserRoleEnum } from 'core/enums';
import { RoleStorageService } from './role.storage.service';

@Injectable({
    providedIn: 'root',
})
export class AuthRedirectService {
    private readonly adminLandingRoles = [
        UserRoleEnum.Admin,
        UserRoleEnum.Root,
        UserRoleEnum.AdminDonor,
        UserRoleEnum.AdminRecipient,
        UserRoleEnum.AdminSubRecipientPlus,
        UserRoleEnum.AdminSubRecipient,
    ];

    constructor(private readonly roleStorageService: RoleStorageService) {}

    public getAuthenticatedLandingUrl(): string {
        const roles = this.roleStorageService.getValue();
        const hasAdminLandingRole = roles?.some(role => this.adminLandingRoles.includes(role));

        return hasAdminLandingRole ? '/meetings' : '/';
    }
}
